import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Urgency() {
  return <section className="py-12 bg-ink" data-id="element-473">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-474">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="bg-gold/5 border border-gold/40 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-475">
          <div className="shrink-0" data-id="element-476">
            <AlertCircle className="w-10 h-10 text-gold" data-id="element-477" />
          </div>

          <div className="space-y-3" data-id="element-478">
            <h3 className="text-xl font-bold text-gold uppercase tracking-wide" data-id="element-479">
              Importante
            </h3>
            <p className="text-cream/90 font-light" data-id="element-480">
              Solo atendemos un número limitado de eventos por fin de semana
              para garantizar la calidad y atención personalizada que cada
              familia merece.
            </p>
            <p className="text-cream/90 font-light" data-id="element-481">
              Los fines de semana de temporada alta (mayo, junio, octubre,
              diciembre) se reservan con meses de anticipación.
            </p>
            <p className="text-cream font-medium pt-2" data-id="element-482">
              Si tu evento está en los próximos 6 meses, no esperes. Las fechas
              más bonitas del año se agotan rápido — y tu celebración merece lo
              mejor.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}